import React, { useCallback, useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { CREDITS_EVENT, fetchCredits, fmtCredits } from "@/lib/credits";

/**
 * CreditsChip — quiet by design. It stays invisible until the balance drops
 * into the last fifth of the month's allowance, then it shows up and stays
 * until you top up. One tap goes to the Credits screen.
 */
export default function CreditsChip() {
  const [state, setState] = useState(null);

  const load = useCallback(async () => {
    try {
      setState(await fetchCredits());
    } catch {
      /* a missing balance must never break the header */
    }
  }, []);

  useEffect(() => {
    load();
    const onChange = () => load();
    window.addEventListener(CREDITS_EVENT, onChange);
    return () => window.removeEventListener(CREDITS_EVENT, onChange);
  }, [load]);

  if (!state || !state.low) return null;

  const empty = state.empty;
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new CustomEvent("rammy-navigate", { detail: { target: "credits" } }))}
      data-testid="credits-chip"
      data-empty={empty ? "true" : "false"}
      title={empty ? "You're out of credits" : "Credits running low"}
      className={[
        "inline-flex items-center gap-1.5 rounded-full pl-2 pr-2.5 h-7 font-mono text-[11px]",
        "border transition-colors duration-150",
        empty
          ? "border-[var(--rm-done-ink)]/40 text-[var(--rm-done-ink)] bg-[var(--rm-marigold-500)]/12 hover:bg-[var(--rm-marigold-500)]/20"
          : "border-[var(--rammy-border)] text-[var(--rammy-text-sec)] hover:bg-[var(--rammy-surface-alt)]",
      ].join(" ")}
    >
      <Sparkles size={12} />
      <span>{fmtCredits(state.available)}</span>
      <span className="hidden sm:inline opacity-70">{empty ? "· top up" : "left"}</span>
    </button>
  );
}
